import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, ILandingSection, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import Dummy from "./Dummy"
import { TablePrimitive } from "../primitive"
import DataContentEditor from "../landing-edit/editors/data-content-editor"

/* Protopia Ecosystem component */
export interface ITableProps {
    section: ILandingSection
    data: TableContent
}
const Table = ({data, ...props}: ITableProps): JSX.Element => {
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "center" : "flex-start")
    const [justify]       = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "flex-start")
    const [width]         = useState<string>(getCssDemention( data.width,  "inherit" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "inherit" )) 

    useEffect(() => {
        addCSSClass(
            `landing-table-${props.section.id}`,
            `.landing-table-${props.section.id} {
                display: flex;
                align-items: ${alignItems};
                justify-content: ${justify};
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            } 
            `
        )           
        return () => {
            removeCSSClass(`landing-table-${props.section.id}`)
        }
    },[])
    return !!data.data
        ?
        <div className={`landing-content-container landing-menu landing-table-${props.section.id} ${ data.className || "" } `} style={ data.style || {} }  data-type={data.type} data-content-id={data.id}>
            <TablePrimitive 
                primitive={ {
                    ...(data ),
                    section: props.section  
                } as any }
            />
            <DataContentEditor data={data} section={props.section} />
        </div>
        :
        <Dummy {...{ 
            data: {...data, className: `landing-table-${props.section.id}`}, 
            ...props 
        }} /> 
}
export default Table